import { Button } from "@mui/material";
import { IconDownloadAppStore, IconDownloadPlayStore } from "src/components/icons";
import { IMAGE_BUTTON_VARIANTS } from "src/components-mui/base/image-button/constants";
import { ValueOf } from "src/types/utils/value-of";

interface IImageButtonProps {
    url: string;
    target?: string;
    imageVariant?: ValueOf<typeof IMAGE_BUTTON_VARIANTS>;
}

export const ImageButton = ({ url, target, imageVariant }: IImageButtonProps) => {
    return (
        <Button
            component="a"
            href={url}
            target={target}
            variant="ghost"
            sx={{ width: "auto", padding: 0, background: "transparent", "&:hover": { background: "transparent" } }}
        >
            {imageVariant === IMAGE_BUTTON_VARIANTS.APP_STORE ? <IconDownloadAppStore /> : <IconDownloadPlayStore />}
        </Button>
    );
};
